'use client';

import React, { PropsWithChildren } from 'react';
import { MainProviders, MainProvidersProps } from './MainProviders';
import { MaintenanceProviders } from './MaintenanceProviders';
import { getCleanPathname, initializeAxios } from '@ianesthesie-kit/config';
import { AppConfigService } from '@/config';

import '../../public/polyfills';
import '../../styles/globals.css';

const shouldAddHeaders = (url: string | undefined) => {
  if (typeof url !== 'string') {
    return false;
  }
  const path = getCleanPathname(url);
  if (
    /\/auth\/(me|logout)\/?/.test(path) ||
    /\/auth\/(phone|email)\/verify\/?.*/.test(path)
  ) {
    return true;
  }
  return !path.startsWith('/auth/');
};

initializeAxios(AppConfigService.getInstance(), shouldAddHeaders);

type ProvidersProps =
  | ({ type: 'full' } & MainProvidersProps)
  | PropsWithChildren<{ type: 'maintenance' }>;

export const Providers = (props: ProvidersProps) => {
  if (props.type === 'full') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { type: _, ...providersProps } = props;
    return <MainProviders {...providersProps} />;
  }

  if (props.type === 'maintenance') {
    return <MaintenanceProviders>{props.children}</MaintenanceProviders>;
  }
};
